module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_7005.0a1d6a37.png";